
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseCard from '@/components/BaseCard.vue';
import ModalFormConfig from '@/components/modals/ModalFormConfig.vue';
import ModalFormDelete from '@/components/modals/ModalFormDelete.vue';
import ModalFormDuplicate from '@/components/modals/ModalFormDuplicate.vue';
import { BOverlay, BDropdown, BDropdownItem } from 'bootstrap-vue';
import { Form, FormLabel } from '@/models/Form';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';
import { IReports } from '@/store/modules/report';
import { IEntries } from '@/store/modules/entry';

@Component({
    name: 'BaseForm',
    components: {
        'base-card': BaseCard,
        'b-overlay': BOverlay,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'modal-form-config': ModalFormConfig,
        'modal-form-delete': ModalFormDelete,
        'modal-form-duplicate': ModalFormDuplicate,
    },
    computed: mapGetters({
        formLabels: 'formLabels/all',
        users: 'users/all',
        reports: 'reports/all',
        entries: 'entries/all',
    }),
})
export default class BaseForm extends Vue {
    error = '';
    updating = false;
    formLabels!: FormLabel[];

    // getters
    users!: User[];
    reports!: IReports;
    entries!: IEntries;

    @Prop() form!: Form;

    get owner() {
        return this.form.owner;
    }

    get formElementsCount() {
        return this.form.elements.length;
    }

    get reportElementsCount() {
        return this.reports[this.form.uri] ? this.reports[this.form.uri].elements.length : 0;
    }

    get entriesCount() {
        return this.entries[this.form.uri] ? Object.values(this.entries[this.form.uri]).length : 0;
    }

    get formLabel() {
        return this.formLabels.find((f: FormLabel) => {
            return this.form.formLabel === f.id;
        });
    }

    async publish() {
        this.updating = true;

        try {
            const owner: any = this.users.find((u: User) => u.uri === this.form.ownerUri);
            await this.$store.dispatch('forms/update', {
                owner,
                formData: { id: this.form.id, published: !this.form.published },
            });
        } catch (e) {
            this.error = e;
        } finally {
            this.updating = false;
        }
    }
}
